import { Component, Inject, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MatSnackBar, MatDialogRef, MAT_DIALOG_DATA, MatDialog } from '@angular/material';
import { Observable } from 'rxjs';
import { DeleteConfirmModalComponent } from 'src/app/commons/delete-confirm-modal/delete-confirm-modal.component';
import { CourseUnitsService } from 'src/app/services/course-units.service';

@Component({
  selector: 'app-add-unit-modal',
  templateUrl: './add-unit-modal.component.html',
  styleUrls: ['./add-unit-modal.component.scss']
})
export class AddUnitModalComponent implements OnInit {
  unitsForm: FormGroup;
  error: any;
  loading: boolean;

  constructor(public _courseUnitService: CourseUnitsService, public _snackbar: MatSnackBar, public dialogRef: MatDialogRef<any>, public dialog: MatDialog,
    @Inject(MAT_DIALOG_DATA) public data: any) { }

  ngOnInit() {
    console.log("data details", this.data);

    this.createForm(this.data)
  }

  createForm(data?) {
    this.unitsForm = new FormGroup({
      title: new FormControl(data && data.title ? data.title : '', Validators.required),
      unitNo: new FormControl(data && data.unitNo ? data.unitNo : '')
    })
  }
  // UTILITY FUNCTIONS

  closoeDialog(result) {
    this.dialogRef.close(result);
  }

  openDialog(someComponent, data = {}): Observable<any> {
    console.log("OPENDIALOG", "DATA = ", data);
    const dialogRef = this.dialog.open(someComponent, { data });
    return dialogRef.afterClosed();
  }

  delete() {
    this.openDialog(DeleteConfirmModalComponent, 'Unit').subscribe(confirm => {
      if (confirm == '') return
      else if (confirm == 'yes') {
        console.log("what is the value of single unit", this.data);
        this._courseUnitService.deleteUnit(this.data._id).subscribe(units => {
          this.loading = false;
          this.closoeDialog({
            action: 'delete',
            result: 'success',
            data: this.data
          });
        }, err => {
          // alert(err)
          console.log("ERROR IN UNIT DELETE", err)
          this.loading = false;
          this.closoeDialog({
            action: 'delete',
            result: 'err',
            data: err
          });
        });
      }
    })
  }

  submit() {
    this.loading = true
    let obj = {
      title: this.unitsForm.value.title,
      unitNo: this.unitsForm.value.unitNo,
      type: 'unit'
    }
    if (this.data && this.data.courseId) obj['course'] = this.data.courseId
    if (this.data && this.data.course) obj['course'] = this.data.course
    if (this.unitsForm.valid) {
      if (this.data && !this.data.isEdit) {
        this._courseUnitService.addUnit(obj).subscribe(res => {
          console.log("Unit added successfully", res)
          this.closoeDialog(res)
          // this.closoeDialog({
          //   action: 'add',
          //   result: 'success',
          //   data: res
          // });
          this.loading = false
        }, (error) => {
          this.error = error.msg
          this.loading = false
        })
      } else {
        obj['_id'] = this.data._id
        // if (this.data && this.data.courseId) { obj['course'] = this.data.courseId }
        console.log("what is obj", obj);

        this._courseUnitService.updateUnit(obj).subscribe(res => {
          console.log("Unit updated successfully", res)
          // this.closoeDialog(res)
          this.closoeDialog({
            action: 'edit',
            result: 'success',
            data: res
          });
          this.loading = false
        }, (error) => {
          this.error = error.msg
          this.loading = false
        })
      }
    } else {
      this.unitsForm.markAllAsTouched()
      this.loading = false
    }
  }




}
